import type { ReactNode } from 'react';

import { RefreshCw, TriangleAlert } from 'lucide-react';

import { Alert, AlertTitle } from '~/components/ui/alert';
import { Button } from '~/components/ui/button';
import { cn } from '~/lib/utils';

interface ErrorAlertProps {
  /** Bold first line. Pass null to show the message alone. */
  title?: string | null;
  message: ReactNode;
  details?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorAlert({
  title = 'Error',
  message,
  details,
  onRetry,
  className,
}: ErrorAlertProps) {
  return (
    <Alert variant="destructive" role="alert" className={cn(className)}>
      <TriangleAlert data-icon="inline-start" />
      <div className="flex items-start justify-between gap-4">
        <div>
          {title !== null && <AlertTitle>{title}</AlertTitle>}
          {message}
          {details && <pre className="mt-2 text-xs whitespace-pre-wrap opacity-80">{details}</pre>}
        </div>
        {onRetry && (
          <Button variant="ghost" size="sm" onClick={onRetry}>
            <RefreshCw data-icon="inline-start" />
            Retry
          </Button>
        )}
      </div>
    </Alert>
  );
}
